// Pharmacy webshop lives on app.treet.fi, marketing site links and redirects point there
// so Google indexes one URL per pharmacy (the app), not duplicate treet.fi detail pages.

const toSlug = (value: string) =>
  value
    .toLowerCase()
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/å/g, 'a')
    .replace(/\s+/g, '-');

export const pharmacySlug = (pharmacy: { slug?: string; name: string }) => pharmacy.slug ?? toSlug(pharmacy.name);

/** Canonical app webshop URL for a pharmacy (uses API url when available). */
export const pharmacyAppUrl = (pharmacy: { slug?: string; name: string; url?: string }) =>
  pharmacy.url ?? `https://app.treet.fi/pharmacy/${pharmacySlug(pharmacy)}`;
